import { render, staticRenderFns } from "./ReactionsV2.view.vue?vue&type=template&id=5133b8bc&scoped=true&"
import script from "./ReactionsV2.view.vue?vue&type=script&lang=js&"
export * from "./ReactionsV2.view.vue?vue&type=script&lang=js&"
import style0 from "./ReactionsV2.view.vue?vue&type=style&index=0&id=5133b8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133b8bc",
  null
  
)

export default component.exports